export enum GenderEnum {
  Male = 'Male',
  Female = 'Female',
  Unspecified = 'Unspecified'
}

export type GenderEnumType = keyof typeof GenderEnum;
